module.exports = __webpack_public_path__ + "static/media/icon_rin08731e5288be6cc51c4c40bb4095fccb.webp";